import { render, staticRenderFns } from "./_Authorizations.vue?vue&type=template&id=183d40a6&scoped=true&"
import script from "./_Authorizations.vue?vue&type=script&lang=ts&"
export * from "./_Authorizations.vue?vue&type=script&lang=ts&"
import style0 from "./_Authorizations.vue?vue&type=style&index=0&id=183d40a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183d40a6",
  null
  
)

export default component.exports